import { forwardRef, ForwardedRef, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { trioUITheme } from '@/styles/theme';
import InputText from '@/trio-ui/InputText';
import { InputSize } from '@/trio-ui/InputText/InputText.component';
import * as Styles from './SearchInput.styles';

export type SearchInputProps = {
  id?: string;
  value?: string;
  onChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size?: InputSize;
  placeholder?: string;
  name?: string;
  testId?: string;
  isDisabled?: boolean;
  errorMessage?: string;
  label?: string;
};

const SearchInput = (
  {
    value,
    onChangeHandler,
    id = 'candidate-search-input',
    size = 'md',
    placeholder = 'Search',
    testId,
    name,
    isDisabled,
    label,
    errorMessage,
    ...props
  }: SearchInputProps,
  ref: ForwardedRef<HTMLInputElement>
): JSX.Element => {
  const [hideIcon, setHideIcon] = useState(false);

  return (
    <Styles.CustomInputGroup id={id} {...props}>
      <Styles.InputContainer $hideSearchIcon={hideIcon}>
        <Styles.CustomInputLeftElement $hideSearchIcon={hideIcon} $hasLabel={!!label}>
          <SearchIcon
            sx={{ color: trioUITheme.colors['neutral-70'], height: '15px', width: 15, zIndex: 2 }}
          />
        </Styles.CustomInputLeftElement>

        <InputText
          data-testid={testId}
          name={name}
          label={label}
          ref={ref}
          value={value}
          onChangeHandler={onChangeHandler}
          size={size}
          isLabelAboveField
          onBlur={() => setHideIcon(!!value)}
          onFocus={() => setHideIcon(true)}
          placeholder={placeholder}
          isDisabled={isDisabled}
          errorMessage={errorMessage}
        />
      </Styles.InputContainer>
    </Styles.CustomInputGroup>
  );
};

export default forwardRef(SearchInput);
